import React, { useEffect, useState, useRef } from "react";
import { useId } from 'react';
import Real_Estate_Reg_Fee from '../Term_conditions/Real_Estate_Reg_Fee';
import Physical_image_2 from '../Select_image/Physical_image_2';
import Real_estate_TS from "../Term_conditions/Real_estate_TS";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPerson, faPersonDress, faXmark } from '@fortawesome/free-solid-svg-icons';
import Property_document from '../Select_image/Property_document';
import Phsycal_image from '../Select_image/Phsycal_image';
import Fee from "./Agencies/Fee";
import Doc_quiz from "./Agencies/Doc_quiz";
import Upload_doc from "./Agencies/Upload_doc";
import Apply_agreement from "./Agencies/Apply_agreement";
import Back_id from "./Agencies/Back_id";
import Front_id from "./Agencies/Front_id";
import Property_Images from "./Agencies/Property_images";
import '../../Work-css/Agencies.css';
import { v4 as uuidv4 } from 'uuid';


function Real_Estate_Portal({real_estate_portal}) {

  const [physical_image, setPhsicalimg] = useState(false)
  const [physical_image_2, setPhsicalimg_2] = useState(false)
  const [propertyDoc, setPropoertyDoc] = useState(false)
  const [realestreg, setRealEST] = useState(false)
  const [schoolPortTS, setSchoolPPTS] = useState(false)

  const [fee, setFee] = useState(false)
  const [agreementquiz, setAgreementq] = useState(false)
  const [uploadagreement, setUploadagreenment] = useState(false)
  const [portal, setPortal] = useState(false)
  const [docquiz, setDocquiz] = useState(true)
  const [frontid, setFrontid] = useState(false)
  const [backid, setBackid] = useState(false)
  const [propertyimages, setPropertyimages] = useState(false)

  const [uniq, setUnique] = useState(uuidv4())

  const phy_scr = () =>{

  }



  return (
    <div className='outer_SP'>
    <div className='re_INNER'>
     {fee?(<div className='MPESA_SP'>
      <Fee 
      uniq={uniq}
      setFee={setFee} 
      setAgreementq = {setAgreementq}
      setUploadagreenment = {setUploadagreenment}
      setPortal = {setPortal}
      setDocquiz = {setDocquiz}
      setFrontid = {setFrontid}
      setBackid = {setBackid}
      setPropertyimages = {setPropertyimages}
      />
      </div>):('')}
     {docquiz?(<div className='MPESA_SP'><Doc_quiz
           setFee={setFee} 
           setAgreementq = {setAgreementq}
           setUploadagreenment = {setUploadagreenment}
           setPortal = {setPortal}
           setDocquiz = {setDocquiz}
           setFrontid = {setFrontid}
           setBackid = {setBackid}
           setPropertyimages = {setPropertyimages} />
           </div>):('')}
     {uploadagreement?(<div className='MPESA_SP'><Upload_doc
           setFee={setFee} 
           setAgreementq = {setAgreementq}
           setUploadagreenment = {setUploadagreenment}
           setPortal = {setPortal}
           setDocquiz = {setDocquiz}
           setFrontid = {setFrontid}
           setBackid = {setBackid}
           setPropertyimages = {setPropertyimages} 
           /></div>):('')}
     {agreementquiz?(<div className='MPESA_SP'><Apply_agreement
           uniq={uniq}
           setFee={setFee} 
           setAgreementq = {setAgreementq}
           setUploadagreenment = {setUploadagreenment}
           setPortal = {setPortal}
           setDocquiz = {setDocquiz}
           setFrontid = {setFrontid}
           setBackid = {setBackid}
           setPropertyimages = {setPropertyimages}
            /></div>):('')}

     {frontid?(<div className='MPESA_SP'><Front_id
           uniq={uniq}
           setFee={setFee} 
           setAgreementq = {setAgreementq}
           setUploadagreenment = {setUploadagreenment}
           setPortal = {setPortal}
           setDocquiz = {setDocquiz}
           setFrontid = {setFrontid}
           setBackid = {setBackid}
           setPropertyimages = {setPropertyimages}
            /></div>):('')}
     {backid?(<div className='MPESA_SP'><Back_id
           uniq={uniq}
           setFee={setFee} 
           setAgreementq = {setAgreementq}
           setUploadagreenment = {setUploadagreenment}
           setPortal = {setPortal}
           setDocquiz = {setDocquiz}
           setFrontid = {setFrontid}
           setBackid = {setBackid}
           setPropertyimages = {setPropertyimages}
            /></div>):('')}
     {propertyimages?(<div className='MPESA_SP'><Property_Images
           uniq={uniq}
           setFee={setFee} 
           setAgreementq = {setAgreementq}
           setUploadagreenment = {setUploadagreenment}
           setPortal = {setPortal}
           setDocquiz = {setDocquiz}
           setFrontid = {setFrontid}
           setBackid = {setBackid}
           setPropertyimages = {setPropertyimages}
            /></div>):('')}
    
     {portal?(<div className='Student_portal'>
        <p className='fill_In'>Fill In</p>
        <input placeholder='Partner' />
        <input placeholder='property name' />
        <input placeholder='Location' />
        <input placeholder='Contact 1' />
        <input placeholder='Contact 2' />
        <input placeholder='Accomodation Rates' />
        <input placeholder='Agreement Duration' />
        <input placeholder='Payment Gateway' />
        <div>
        <div className='DOM_PH'>date of Agreement:</div>
        <input type='date' placeholder='date of admission' />
        </div>
        
       
        <div className='submit' onClick={phy_scr}>Submit</div>
        
    </div>):('')}

    

    <div className='MPESA_SP'>
       <Phsycal_image schoolPortTS={setSchoolPPTS} />
    </div>

    <div className='T_C'>
       <Real_estate_TS realestreg={setRealEST} />
    </div>
    
    <div className='MPESA_SP'>
       <Real_Estate_Reg_Fee />
    </div>
    
    <div className='MPESA_SP'>
       <Physical_image_2 propertyDoc={setPropoertyDoc} />
    </div>

    <div className='MPESA_SP'>
       <Property_document school_port={setSchoolPPTS} />
    </div>
    
    </div>
    </div>
  )
}

export default Real_Estate_Portal